/**
 * Mobile Menu Dropdown Behavior
 * Replaces sliding submenu with dropdown behavior for improved mobile navigation
 */
document.addEventListener('DOMContentLoaded', function() {
  // Add class to identify mobile menu for styling
  const menuDrawer = document.querySelector('.menu-drawer');
  if (menuDrawer) {
    menuDrawer.classList.add('dropdown-style');
  }
  
  // Remove any sliding animations by preventing default back button behavior
  const closeButtons = document.querySelectorAll('.menu-drawer__close-button');
  closeButtons.forEach(button => {
    if (!button.closest('.close-navigation-container')) {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        // Find the parent details element and close it
        const parentDetails = this.closest('details');
        if (parentDetails) {
          parentDetails.removeAttribute('open');
        }
      });
    }
  });
  
  // Ensure submenus properly collapse when parent menu is closed
  const parentDetails = document.querySelectorAll('.menu-drawer__menu > li > details');
  parentDetails.forEach(details => {
    details.addEventListener('toggle', function() {
      if (!this.open) {
        // Close all child details elements when parent is closed
        const childDetails = this.querySelectorAll('details');
        childDetails.forEach(child => {
          child.removeAttribute('open');
        });
      }
    });
  });
});
